import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { Grid, Paper, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { showModal, userDataReducer, storeShopList } from "../../../redux/counterSlice";
// import { useAdmin } from "../../components/Admin/Admin";
import { useAdmin } from "../../../components/Admin/Admin";
// import { FormInputText } from "../../components/form-components/FormInputText";
import { FormInputText } from "../../../components/form-components/FormInputText";
// import { FormInputDropdown } from "../../components/form-components/FormInputDropdown";
import { FormInputDropdown } from "../../../components/form-components/FormInputDropdown";
import { shopLoginSchema } from "../../../app/schema";

function LoginShop() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const admin = useAdmin();
  const setAdminContext = admin?.login;

  const [shopList, setShopList] = useState([]);

  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(shopLoginSchema),
    defaultValues: {
      shop_id: "",
      password: "", 
      display_name: "",
    },
  });

  const selectedShopId = watch("shop_id");
  useEffect(() => {
    sessionStorage.setItem("lastLoginPath", window.location.pathname);
  }, []);
  // Set display name when shop_id changes
  useEffect(() => {
    if (selectedShopId) {
      const selectedShop = shopList.find(
        (shop) => String(shop.shop_details_id) === String(selectedShopId)
      );
      if (selectedShop) {
        setValue("display_name", selectedShop.shop_name); // Just for UI
      }
    }
  }, [selectedShopId, shopList, setValue]);

  // Fetch shop list
  useEffect(() => {
    const fetchShops = async () => {
      try {
        const res = await axios.get("/getAllActiveShopDetails");
        if (res?.data?.data) {
          setShopList(res.data.data);
          // dispatch(storeShopList(res.data.data));
        }
      } catch (err) {
        dispatch(showModal({ msg: "Failed to load shops", error: true }));
      }
    };
    fetchShops();
  }, [dispatch]);

  // Handle form submission
  const login = async (data) => {
    const selectedShop = shopList.find(
      (shop) => String(shop.shop_details_id) === String(data.shop_id)
    );

    if (!selectedShop) {
      dispatch(showModal({ msg: "Invalid shop selection", error: true }));
      return;
    }

    const payload = {
      shop_name: selectedShop.shop_code,
      shop_details_id: selectedShop.shop_details_id,
      password: data.password,
    };

    try {
      const response = await axios.post("/loginShop", payload);
      const res = response?.data;

      if (!res?.error) {
        // <-- Store login info in sessionStorage here
        const storageData = {
          token: res?.data,
          loggedIn: true,
        };

        sessionStorage.setItem("userData", JSON.stringify(storageData));

        sessionStorage.setItem("loginType", "shop");
        sessionStorage.setItem("shop_id", selectedShop.shop_details_id);
        sessionStorage.setItem("shop_name", selectedShop.shop_name);

        dispatch(userDataReducer(storageData));
        if (typeof setAdminContext === "function") {
          setAdminContext(res?.data);
        }
        navigate("/dashboard");
        toast.success("Logged in successfully");
      } else {
        dispatch(
          showModal({ msg: res?.message || "Login failed", error: true })
        );
      }
    } catch (error) {
      dispatch(
        showModal({ msg: error?.message || "Server error", error: true })
      );
    }
  };

  const paperStyle = {
    padding: 20,
    maxWidth: "400px",
    margin: "10%",
  };
  const btnstyle = { margin: "8px 0", background: "#E63D24" };

  return (
    <Box
      className="login-page"
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper elevation={10} style={paperStyle} className="bg-light">
        <form onSubmit={handleSubmit(login)}>
          <Grid container spacing={2}>
            <Grid item xs={12} align="center">
              <img
                src={require("../../../assets/logo.png")}
                alt="Logo"
                width={200}
              />
            </Grid>

            {/* Dropdown for shop */}
            <Grid item xs={12}>
              <FormInputDropdown
                name="shop_id"
                control={control}
                label="Select Shop"
                type="single"
                options={shopList.map((shop) => ({
                  id: shop.shop_details_id,
                  name: shop.shop_name,
                }))}
                errors={errors}
              />
            </Grid>

            {/* Read-only display of shop name */}
            <Grid item xs={12}>
              <Controller
                name="display_name"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <FormInputText
                    {...field}
                    control={control}
                    label="Shop Name"
                    errors={errors}
                    type="text"
                    readOnly
                  />
                )}
              />
            </Grid>

            {/* Password input */}
            <Grid item xs={12}>
              <FormInputText
                name="password"
                control={control}
                label="Password"
                errors={errors}
                type="password"
              />
            </Grid>

            {/* Submit button */}
            <Grid item xs={12}>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                style={btnstyle}
                fullWidth
              >
                Login
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
}

export default LoginShop;
